export const apiCallsNoAuthorizationWhitelist = ['pavecommute.app/api/pods-summary'];
